import React,{useState,useEffect} from "react";
import './DashboardContent.css';
import { useSelector, useDispatch } from "react-redux";
import {getProjectMasterList} from "../function-components/Redux/ProjectMasterSlice";
import { Chart } from 'primereact/chart';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import { Dropdown } from 'primereact/dropdown';

                
      

function DashboardContent() {
  const dispatch = useDispatch();
  const [selectedYearPortal, setSelectedYearPortal] = useState(null);
  const [selectedYearCR, setSelectedYearCR] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const projectData = useSelector((state) => state.projectMaster.projectMasterList);
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [CRchartData, setCRChartData] = useState({});
  const [LKMSiteData, setLKMSiteData] = useState({});
  const [CRchartOptions, setCRChartOptions] = useState({});
  const [LKMSiteDataOptions, setLKMSiteDataOptions] = useState({});
  const years = [
        { name: 'FY24', code: 'FY24' },
        { name: 'FY23', code: 'FY23' },
        { name: 'FY22', code: 'FY22' },
        
    ];
    const crYears = [
        { name: 'FY24', code: 'FY24' },
       
    ];
  const filterPortalFy24 = [...projectData.filter((project) => project.year === "FY24" && 
  project.request_id.includes("Portal"))];
  const filterPortalTelentFy24 = [...projectData.filter((project) => project.year === "FY24" && 
  project.request_id.includes("Portal") &&
  (project.name.includes("Talent Academy") || project.name.includes("University")))];
  const filterPortalTelentFy23 = [...projectData.filter((project) => project.year === "FY23" && 
  project.request_id.includes("Portal") && 
  (project.name.includes("Talent Academy") || project.name.includes("University")))];
  console.log(filterPortalTelentFy23);
  const filterPortalTelentFy22 = [...projectData.filter((project) => project.year === "FY22" && 
  project.request_id.includes("Portal") && 
  (project.name.includes("Talent Academy") || project.name.includes("University")))];
  console.log(filterPortalTelentFy22);
  const filterPortalFy23 = [...projectData.filter((project) => project.year === "FY23" && 
  project.request_id.includes("Portal"))];
  const filterPortalFy22 = [...projectData.filter((project) => project.year === "FY22" && 
  project.request_id.includes("Portal"))];
  const filterPowerAppFy24 = [...projectData.filter((project) => project.year === "FY24" && 
  project.request_id.includes("PowerApps"))];
  const filterPowerAppFy23 = [...projectData.filter((project) => project.year === "FY23" && 
  project.request_id.includes("PowerApps"))];
  const filterPowerAppFy22 = [...projectData.filter((project) => project.year === "FY22" && 
  project.request_id.includes("PowerApps"))];
  const filterPowerBIFy24 = [...projectData.filter((project) => project.year === "FY24" && 
  project.request_id.includes("PowerBI"))];
  const filterPowerBIFy23 = [...projectData.filter((project) => project.year === "FY23" && 
  project.request_id.includes("PowerBI"))];
  const filterPowerBIFy22 = [...projectData.filter((project) => project.year === "FY22" && 
  project.request_id.includes("PowerBI"))];
  const filterWireframeFy24 = [...projectData.filter((project) => project.year === "FY24" && 
  project.request_id.includes("Wireframe"))];
  const filterWireframeFy23 = [...projectData.filter((project) => project.year === "FY23" && 
  project.request_id.includes("Wireframe"))];
  const filterWireframeFy22 = [...projectData.filter((project) => project.year === "FY22" && 
  project.request_id.includes("Wireframe"))];
  const filterChangeRequestComp = [...projectData.filter((project) => project.request_id.includes("CR") && 
  project.status === "3")];
  const filterChangeRequestInPro = [...projectData.filter((project) => project.request_id.includes("CR") && 
  project.status === "2")];
  const filterChangeRequestInNew = [...projectData.filter((project) => project.request_id.includes("CR") && 
  project.status === "4")];
  const filterChangeRequestInstart = [...projectData.filter((project) => project.request_id.includes("CR") && 
  project.status === "1")];
  
  // const uniqueProjectNames = [...new Set(projectData.map((project) => project.name))];
  // console.log(uniqueProjectNames);
 
  useEffect(() => {   
    dispatch(getProjectMasterList("all"));
  }, []);
  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    yearlyData("FY24")
    changeRequestStatus()
    micrositeCount("FY24")
}, [projectData]);
const micrositeCount =(year) =>{
    const lkmSiteCountFy24 = filterPortalFy24.length - filterPortalTelentFy24.length;
    const lkmSiteCountFy23 = filterPortalFy23.length - filterPortalTelentFy23.length;
    const lkmSiteCountFy22 = filterPortalFy22.length - filterPortalTelentFy22.length;
    if(year === "FY24"){
        const crData = {
            labels: ['Total LKM Sites', 'Total Talent Academies'],
            datasets: [
                {
                    label: 'LKM Sites / Total Talent Academies Count in FY24',
                    data: [lkmSiteCountFy24, filterPortalTelentFy24.length],
                    backgroundColor: [
                        '#7500C0',
                        '#FF7800',
                    ],
                    borderColor: [
                        '#7500C0',
                        '#FF7800',
                    ],
                    borderWidth: 1
                }
            ]
        };
        const crOptions = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }; 
        setLKMSiteData(crData);
        setLKMSiteDataOptions(crOptions)
    } else  if(year === "FY23"){
        const crData = {
            labels: ['Total LKM Sites', 'Total Talent Academies'],
            datasets: [
                {
                    label: 'LKM Sites / Total Talent Academies Count in FY23',
                    data: [lkmSiteCountFy23, filterPortalTelentFy23.length],
                    backgroundColor: [
                        '#7500C0',
                        '#FF7800',
                    ],
                    borderColor: [
                        '#7500C0',
                        '#FF7800',
                    ],
                    borderWidth: 1
                }
            ]
        };
        const crOptions = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }; 
        setLKMSiteData(crData);
        setLKMSiteDataOptions(crOptions)
    } else {
            const crData = {
                labels: ['Total LKM Sites', 'Total Talent Academies'],
                datasets: [
                    {
                        label: 'LKM Sites / Total Talent Academies Count in FY22',
                        data: [lkmSiteCountFy22, filterPortalTelentFy22.length],
                        backgroundColor: [
                            '#7500C0',
                            '#FF7800',
                        ],
                        borderColor: [
                            '#7500C0',
                            '#FF7800',
                        ],
                        borderWidth: 1
                    }
                ]
            };
            const crOptions = {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }; 
            setLKMSiteData(crData);
            setLKMSiteDataOptions(crOptions)
        }
    
    
}
const changeRequestStatus =() =>{
    const crData = {
        labels: ['Completed', 'In Progress', 'New', 'Yet to Start'],
        datasets: [
            {
                label: 'Total Portal Count in FY24',
                data: [filterChangeRequestComp.length, filterChangeRequestInPro.length, 
                    filterChangeRequestInNew.length ,filterChangeRequestInstart.length],
                backgroundColor: [
                    '#7500C0',
                    '#FF7800',
                    '#FF3246',
                    '#A203FF'
                ],
                borderColor: [
                    '#7500C0',
                    '#FF7800',
                    '#FF3246',
                    '#A203FF'
                ],
                borderWidth: 1
            }
        ]
    };
const crOptions = {
    scales: {
        y: {
            beginAtZero: true
        }
    }
};
  setCRChartData(crData);
  setCRChartOptions(crOptions)
}
const onChangeYear = (e, label) => {
    if(label === "portalDetail") {
        setSelectedYearPortal(e.value)
        yearlyData(e.value.name)
    } else {
        setSelectedYear(e.value)
        micrositeCount(e.value.name)
    }
   
}
const yearlyData = (value) => {
    if(value === "FY24") {
        const data = {
            labels: ['Portal', 'Wireframe Only', 'Power App', 'Power BI'],
            datasets: [
                {
                    label: 'Total Portal Count in FY24',
                    data: [filterPortalFy24.length,filterWireframeFy24.length,filterPowerAppFy24.length, filterPowerBIFy24.length],
                    backgroundColor: [
                        '#7500C0',
                        '#FF7800',
                        '#FF3246',
                        '#A203FF'
                      ],
                      borderColor: [
                        '#7500C0',
                        '#FF7800',
                        '#FF3246',
                        '#A203FF'
                      ],
                      borderWidth: 1
                }
            ]
        };
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        };
        setChartData(data);
        setChartOptions(options);
    } else if(value === "FY23"){
        const data = {
            labels: ['Portal', 'Wireframe Only', 'Power App', 'Power BI'],
            datasets: [
                {
                    label: 'Total Portal Count in FY23',
                    data: [filterPortalFy23.length,filterWireframeFy23.length,filterPowerAppFy23.length, filterPowerBIFy23.length],
                    backgroundColor: [
                        '#7500C0',
                        '#FF7800',
                        '#FF3246',
                        '#A203FF'
                      ],
                      borderColor: [
                        '#7500C0',
                        '#FF7800',
                        '#FF3246',
                        '#A203FF'
                      ],
                      borderWidth: 1
                }
            ]
        };
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        };
        setChartData(data);
        setChartOptions(options);
    } else {
        const data = {
            labels: ['Portal', 'Wireframe Only', 'Power App', 'Power BI'],
            datasets: [
                {
                    label: 'Total Portal Count in FY23',
                    data: [filterPortalFy22.length,filterWireframeFy22.length,filterPowerAppFy22.length, filterPowerBIFy22.length],
                    backgroundColor: [
                        '#7500C0',
                        '#FF7800',
                        '#FF3246',
                        '#A203FF'
                      ],
                      borderColor: [
                        '#7500C0',
                        '#FF7800',
                        '#FF3246',
                        '#A203FF'
                      ],
                      borderWidth: 1
                }
            ]
        };
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        };
        setChartData(data);
        setChartOptions(options);
    }
}
    return (
      <>
     <div className="container">
        <h1>Project Overview</h1>
        <div className="Section">
            <div className=" projectDetaillf">
             <h2>Project Details</h2>
                <div className="cardBorder">
                    <div className="card flex">
                        <Dropdown value={selectedYearPortal} 
                        onChange={(e) => onChangeYear(e, "portalDetail")} 
                        options={years} optionLabel="name"  placeholder="Select a year" 
                        className="dropDown w-full md:w-14rem" />
                    </div>
                    <Chart type="bar" data={chartData} options={chartOptions} className="piChatHeight"/>
                </div>
            </div>
            
            <div className=" projectDetailrg">
                <h2>Change Request Details</h2>
                <div className="cardBorder">
                    <div className="card flex">
                        <Dropdown value={selectedYearCR} 
                        //onChange={(e) => onChangeYear(e, "LKMSite")} 
                        options={crYears} optionLabel="name"  placeholder="Select a year" 
                        className="dropDown w-full md:w-14rem" />
                    </div>
                    <Chart type="bar" data={CRchartData} options={CRchartOptions} 
                    className="piChatHeight" />
                </div>
            </div>
        </div>
        <div className="Section">
            <div className=" projectDetaillf">
             <h2>Total count of LKM Sites / Talent Academies</h2>
                <div className="cardBorder_talentacademies">
                    <div className="card flex">
                        <Dropdown value={selectedYear} 
                        onChange={(e) => onChangeYear(e, "LKMSite")} 
                        options={years} optionLabel="name"  placeholder="Select a year" 
                        className="dropDown w-full md:w-14rem" />
                    </div>
                    <Chart type="bar" data={LKMSiteData} options={LKMSiteDataOptions} className="piChatHeight"/>
                </div>
                
            </div>
            
            <div className="card projectDetailrg">
                {/* <h2>sdsdsdsd</h2>
                <Chart type="bar" data={CRchartData} options={CRchartOptions} 
                className="piChatHeight" /> */}
            </div>
        </div>
        {/* <div className="Section">
            <div className=" projectDetaillf card flex justify-content-center">
                <Chart type="doughnut" data={CRchartData} options={CRchartOptions} className="piChatHeight" />
            </div>
        </div> */}
        
     </div>
    
      
      </>
    )
  }
  
  export default DashboardContent;